import { createSegmenter } from './createSegmenter';

export const segmenter: Intl.Segmenter | null = createSegmenter();
